import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import "../styles/footer.css";

const Footer = () => {
  const links = [
    "Home",
    "About",
    "Menu",
    "Reservations",
    "Order Online",
    "Login",
  ];

  const contacts = [
    {
      text: "678 Pisa Ave, Chicago, IL 60611",
      icon: faLocationDot,
    },
    {
      text: "(312) 593-2744",
      icon: faPhone,
    },
    {
      text: "customer@littlelemon.com",
      icon: faEnvelope,
    },
  ];

  const socials = [faFacebook, faTwitter, faInstagram, faYoutube];

  return (
    <footer>
      <div className="footer-container">
        <div>
          <Link to={"/"}>
            <img
              className="footer-logo"
              src="img/footer-logo.png"
              alt="Little Lemon logo"
            />
          </Link>
        </div>

        <div className="sitemap">
          <h2>Sitemap</h2>
          <ul>
            {links.map((link) => (
              <li>
                <Link
                  to={link === "Home" ? "/" : "/" + link.toLocaleLowerCase()}
                >
                  {link}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="contact">
          <h2>Contact us</h2>
          <ul>
            {contacts.map(({ text, icon }) => (
              <li>
                <span>
                  <FontAwesomeIcon icon={icon} size="sm" />
                </span>
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="connect">
          <h2>Connect with us</h2>
          <ul>
            {socials.map((icon) => (
              <li>
                <FontAwesomeIcon icon={icon} size="2x" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
